
@switch (columnId) {
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('organizationName') {
    <lib-text-table-column>
      {{ element.organizationName }}
    </lib-text-table-column>
  }
  @case ('dba') {
    <lib-text-table-column>
      {{ element.dba }}
    </lib-text-table-column>
  }
  @default {
  }
}
